<template>
  <v-container grid-list-md>
    <v-layout wrap align-center justify-center>
      <v-flex xs12>
        <v-card>
          <v-form @submit="changePassword">
            <v-card-title>
              <span class="headline">{{$t('system-admin-password')}}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      autofocus
                      type="password"
                      v-model="oldPassword"
                      :label="$t('system-admin-password-current')"
                      required
                      prepend-icon="lock_open"
                      :rules="passwordRules"
                    ></v-text-field>
                    <v-text-field
                      type="password"
                      v-model="newPassword"
                      :label="$t('system-admin-password-new')"
                      required
                      prepend-icon="lock"
                      :rules="passwordRules"
                    ></v-text-field>
                    <v-text-field
                      type="password"
                      v-model="confirmPassword"
                      :label="$t('system-admin-password-confirm')"
                      required
                      prepend-icon="lock"
                      :rules="passwordRules"
                    ></v-text-field>
                    <transition name="fade">
                      <v-alert :value="error" type="error">{{error}}</v-alert>
                    </transition>
                    <transition name="fade">
                      <v-alert :value="success" type="success">{{success}}</v-alert>
                    </transition>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn type="submit">{{$t('save')}}</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <span class="headline">{{$t('system-settings')}}</span>
          </v-card-title>
          <v-card-text>
            <transition name="fade">
              <v-alert :value="errorDownload" type="error">{{errorDownload}}</v-alert>
            </transition>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn @click="downloadSettings">{{$t('system-download-settings')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import ApiService from "@/common/api.service";

export default {
  name: "SystemPassword",
  data: () => ({
    errorDownload: null,
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
    error: null,
    success: null,
    passwordRules: [
      v =>
        /.{4,20}/.test(v) ||
        v.length == 0 ||
        "Password must be between 4 and 20 characters"
    ]
  }),
  methods: {
    downloadSettings() {
      ApiService.query("/system/settings", { responseType: "blob" })
        .then(response => {
          //console.log(response);

          if (response.headers["content-type"] == "application/octet-stream") {
            let data = response.data;
            var blob = new Blob([data], { type: "application/octet-stream" });
            var fileURL = window.URL.createObjectURL(blob);
            var fileLink = document.createElement("a");
            console.log(fileURL);
            fileLink.href = fileURL;
            let currentDateWithFormat = new Date()
              .toJSON()
              .slice(0, 19)
              .replace(/:/g, "-")
              .replace("T", " ");

            fileLink.setAttribute(
              "download",
              "GW2IP " + currentDateWithFormat + ".bin"
            );
            document.body.appendChild(fileLink);
            fileLink.click();
          } else {
            this.errorDownload =
              "Not supported. Please check if an update is available";
          }
        })
        .catch(error => {
          console.error(error);
          this.errorDownload = error.message;
        });
    },
    changePassword(event) {
      event.preventDefault();
      this.success = null;
      this.error = null;
      if (this.newPassword == this.confirmPassword) {
        this.$store
          .dispatch("system/changePassword", {
            old: this.oldPassword,
            new: this.newPassword,
            confirm: this.confirmPassword
          })
          .then(() => {
            this.success = "Operation complete succesfully";
          })
          .catch(e => {
            console.log(e.response.data);
            this.error = e.response.data.message || e;
          });
      } else {
        this.error = "New and confirm Password do not match";
      }
    }
  }
};
</script>
